import * as ActionTypes from './ActionTypes'

export function setShouldStartSync(isAutomatic, errorCallback) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNSYNC_MANAGER_SHOULD_START_SYNC,
      isAutomatic,
      errorCallback,
    })
  }
}

export function setShouldStopSync() {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNSYNC_MANAGER_SHOULD_STOP_SYNC,
    })
  }
}

export function setDataIsUploading(dataIsUploading) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNSYNC_MANAGER_SET_DATA_IS_UPLOADING,
      dataIsUploading,
    })
  }
}

export function setSafIsUploading(safIsUploading) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNSYNC_MANAGER_SET_SAF_IS_UPLOADING,
      safIsUploading,
    })
  }
}

export function setSafStatusRequesting(safStatusRequesting) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNSYNC_MANAGER_SET_SAF_STATUS_REQUESTING,
      safStatusRequesting,
    })
  }
}

export function setSafStatusProgress(remainingOrders) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNSYNC_MANAGER_SET_SAF_STATUS_PROGRESS,
      remainingOrders,
    })
  }
}

export function setSomethingToSync(stateCount, safCount, dataCount) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.VNSYNC_MANAGER_SET_SOMETHING_TO_SYNC,
      stateCount,
      safCount,
      dataCount,
    })
  }
}
